import React from 'react';
import _ from "lodash";
import moment from 'moment';
import 'moment-timezone';
import "react-bootstrap-table/css/react-bootstrap-table.css";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { convertToUTC, convertFromUTC } from '../../../util/convert_timezone';


const referralState = (props) => {

  const { userType, typeId, referral, displayedList, startDate, errors, 
    name, email, onNameChange, onEmailChange, onDelete, vin, vehicleEntered, vinGood, onVINChange, 
    onSubmit, onCancel, action, onClaimReferral, onConvertToEstimate } = props;

    const messageBoxStyle = {
      backgroundColor: "#FF7E33", // Light orange / bisque color
      padding: "15px 20px",
      borderRadius: "8px",
      marginTop: "10px",
      marginBottom: "10px",
      boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
      wordWrap: "break-word", // Ensures text wraps properly
      maxWidth: "100%",
      textAlign: "center" // Left align for better readability of wrapped text
    };

    const stateMessage = (state, referral, bonus) => {
      //console.log("Referral State : ", referral);
      switch (state) {
        case "NEW":
          return <div>
            <h6>Sale successfully recorded!</h6>
            <h6>We're reaching out to your customer about vehicle protection options.</h6>
          </div>;
        case "CONTACT":
          return <div>
            <h6>Customer email sent successfully!</h6>
            <h6>Next: They'll review their vehicle protection options.</h6>
          </div>;
        case "VIEWED":
          return <div>
            <h6>Great progress! Customer has viewed the benefits page.</h6>
            <h6>Next: They'll receive pricing details from a local specialist.</h6>
          </div>;
        case "CLAIMED":
          return <div>
            <h6>Great news! {referral.claimed_specialist_name || 'A specialist'} has claimed this lead.</h6>
            <h6>They'll contact your customer within 24 hours. Your {bonus} bonus is pending completion.</h6>
          </div>;
        case "OFFERED":
          return <div>
            <h6>Customer is interested in {referral.requested_service}!</h6>
            <h6>We've sent this lead to local specialists. When they book, you'll earn a {bonus} bonus.</h6>
          </div>;
        case "CONVERTED":
          return <div>
            <h6>Specialist has created an estimate for your customer!</h6>
            <h6>They'll present pricing and schedule the work. Your {bonus} bonus is pending completion.</h6>
          </div>;
        case "BOOKED":
          return <div>
            <h6>Success! Customer appointment confirmed for {referral.requested_service}.</h6>
            <h6>Your {bonus} bonus is pending completion.</h6>
          </div>;
        case "COMPLETED":
          return <div>
          <h6>Congratulations! Your {bonus} bonus has been approved.</h6>
          <h6>Check your email at the end of the month for your total payout.</h6>
        </div>;
        default:
          break;
      }    };
  

    function isEmpty(obj) {
    for (var key in obj) {
      if (obj.hasOwnProperty(key))
        return false;
    }
    return true;
  }
   
 // //console.log ("referral State Props : ", props);
  
  // if nothing selected, selected item isn't in the displayed list, we are done
  if (isEmpty(referral) && action === "display") {
    return null;
  } else {

    let check = [];
    check = displayedList.filter(item => (item.referralId === referral.referralId));

    if (check.length === 0 && action === "display") {
      return null;
    } else {

  let bonus = "$25";
  if (referral.requested_service === "PPF")
    bonus = "$100";

  
     
//************************************************************************
//*******************  Dealer Referral Page ******************************
//************************************************************************


// *************************************************
// Dealer Entering a new referral for the dealership
// *************************************************
if ( action === "add" 
    && userType === "dealer") {
      //console.log ("Any errors : ", errors);
return (
    <React.Fragment>
          <div className="card text-center">
            <div className="mt-4 mb-4">
              <h6>Date Vehicle Sold : {moment().format("MM/DD/YYYY")}</h6>
                <div>
                  <form>
                  <div className="form-row justify-content-md-center">
                    <div className="form-group col-lg-2 text-center">
                      <label className="bold">Enter VIN #</label>
                    </div>
                    <div className="form-group col-lg-4">
                    <input 
                        name="vin"
                        id={vin} 
                        value={vin}
                        onChange={onVINChange}
                        error={errors['vin']}/>
                        {errors['vin'] && <div className="alert alert-danger">{errors['vin']}</div>}
                      </div>
                    </div>
                    <div className="form-row justify-content-md-center">
                    <div className="form-group col-lg-2 text-center">
                      <label className="bold">Customer Name</label>
                    </div>
                    <div className="form-group col-lg-4">
                    <input 
                        name="name"
                        id={name} 
                        value={name}
                        onChange={onNameChange}
                        error={errors['name']}/>
                        {errors['name'] && <div className="alert alert-danger">{errors['name']}</div>}
                      </div>
                    </div>
                    <div className="form-row justify-content-md-center">
                    <div className="form-group col-lg-2 text-center">
                      <label className="bold">Customer Email</label>
                    </div>
                    <div className="form-group col-lg-4">
                    <input 
                        name="email"
                        id={email} 
                        value={email}
                        onChange={onEmailChange}
                        error={errors['email']}/>
                        {errors['email'] && <div className="alert alert-danger">{errors['email']}</div>}
                      </div>
                    </div>
                </form>
                </div>
              
              <button type="button" onClick={onSubmit} className="button btn-success m-2 buttons" disabled={!isEmpty(errors) && !vinGood} >ADD</button>
              <button type="button" onClick={() => onCancel(referral)} className="button m-2 buttons">CANCEL</button>
          </div>
        </div>
    </React.Fragment>
  )}

//************************************************************************
//*******************  Specialist Referral Pages *************************
//************************************************************************

// *************************************************
// Specialist adding a new lead
// *************************************************
if (action === "add" && userType === "installer") {
  const { years, makes, models, selectedYear, selectedMake, selectedModel,
          onYearChange, onMakeChange, onModelChange } = props;

  const makeList = makes ? makes.map(m => m.name) : [];
  makeList.unshift("Make");
  const modelList = models ? models.map(m => m.name) : [];
  modelList.unshift("Model");

  return (
    <React.Fragment>
      <div className="card text-center">
        <div className="mt-4 mb-4">
          <h6>Add New Lead</h6>
          <div>
            <form>
              <div className="form-row justify-content-md-center">
                <div className="form-group col-lg-2 text-center">
                  <label className="bold">Customer Name *</label>
                </div>
                <div className="form-group col-lg-4">
                  <input
                    name="name"
                    id={name}
                    value={name}
                    onChange={onNameChange}
                    placeholder="John Smith"
                    className="form-control"
                  />
                  {errors['name'] && <div className="alert alert-danger">{errors['name']}</div>}
                </div>
              </div>
              <div className="form-row justify-content-md-center">
                <div className="form-group col-lg-2 text-center">
                  <label className="bold">Customer Email *</label>
                </div>
                <div className="form-group col-lg-4">
                  <input
                    name="email"
                    id={email}
                    value={email}
                    onChange={onEmailChange}
                    placeholder="john@example.com"
                    className="form-control"
                  />
                  {errors['email'] && <div className="alert alert-danger">{errors['email']}</div>}
                </div>
              </div>
              <div className="form-row justify-content-md-center">
                <div className="form-group col-lg-2 text-center">
                  <label className="bold">Customer Phone *</label>
                </div>
                <div className="form-group col-lg-4">
                  <input
                    name="phone"
                    value={props.phone}
                    onChange={props.onPhoneChange}
                    placeholder="(555) 123-4567"
                    className="form-control"
                  />
                  {errors['phone'] && <div className="alert alert-danger">{errors['phone']}</div>}
                </div>
              </div>

              <hr />
              <h6 className="text-muted mb-3">Vehicle Information</h6>

              <div className="form-row justify-content-md-center">
                <div className="form-group col-lg-2">
                  <label className="bold">Year *</label>
                  <select
                    name="selectedYear"
                    value={selectedYear}
                    onChange={onYearChange}
                    className="form-control"
                  >
                    {years && years.map((year, idx) => (
                      <option key={idx} value={year}>{year}</option>
                    ))}
                  </select>
                </div>
                <div className="form-group col-lg-2">
                  <label className="bold">Make *</label>
                  <select
                    name="selectedMake"
                    value={selectedMake}
                    onChange={onMakeChange}
                    className="form-control"
                    disabled={selectedYear === "Year"}
                  >
                    {makeList.map((make, idx) => (
                      <option key={idx} value={make}>{make}</option>
                    ))}
                  </select>
                </div>
                <div className="form-group col-lg-2">
                  <label className="bold">Model *</label>
                  <select
                    name="selectedModel"
                    value={selectedModel}
                    onChange={onModelChange}
                    className="form-control"
                    disabled={selectedMake === "Make"}
                  >
                    {modelList.map((model, idx) => (
                      <option key={idx} value={model}>{model}</option>
                    ))}
                  </select>
                </div>
              </div>

              <hr />

              <div className="form-row justify-content-md-center">
                <div className="form-group col-lg-2 text-center">
                  <label className="bold">Service Interest *</label>
                </div>
                <div className="form-group col-lg-4">
                  <select
                    name="serviceInterest"
                    value={props.serviceInterest}
                    onChange={props.onServiceChange}
                    className="form-control"
                  >
                    <option value="">Select a service...</option>
                    <option value="Paint Protection Film (PPF)">Paint Protection Film (PPF)</option>
                    <option value="Window Tint">Window Tint</option>
                    <option value="Ceramic Coating">Ceramic Coating</option>
                    <option value="Paint Correction">Paint Correction</option>
                    <option value="Vinyl Wrap">Vinyl Wrap</option>
                    <option value="Other">Other</option>
                  </select>
                </div>
              </div>
            </form>
          </div>

          <button
            type="button"
            onClick={props.onSubmitLead}
            className="button btn-success m-2 buttons"
            disabled={!name || !email || !props.phone || selectedYear === "Year" || selectedMake === "Make" || selectedModel === "Model" || !props.serviceInterest}
          >
            ADD LEAD
          </button>
          <button type="button" onClick={() => onCancel(referral)} className="button m-2 buttons">CANCEL</button>
        </div>
      </div>
    </React.Fragment>
  )
}

// *************************************************
// Specialist display of a referral (OFFERED state)
// *************************************************
else if (userType === "installer" && action === "display" && referral.specialist_action === 'available') {

return (
    <React.Fragment>
          <div className="card text-center">
            <div className="mt-4 mb-4">
                <h6>Lead Details</h6>
                <div className="text-left" style={{ maxWidth: '300px', margin: '0 auto' }}>
                  <p><strong>Customer:</strong> {referral.customer_name}</p>
                  {referral.requested_service && (
                    <p><strong>Service Requested:</strong> {referral.requested_service}</p>
                  )}
                  {referral.zip_code && (
                    <p><strong>Location Area:</strong> {referral.zip_code}</p>
                  )}
                  <p><strong>Vehicle:</strong> {referral.Year} {referral.Make} {referral.Model}</p>
                </div>
                <div className="mt-3 mb-3">
                  <p><strong>Claim this lead to receive customer contact details and begin the conversion process.</strong></p>
                </div>
                <button
                  type="button"
                  onClick={() => onClaimReferral(referral)}
                  className="button btn-success m-2 buttons"
                >
                  CLAIM LEAD
                </button>
                <button type="button" onClick={() => onCancel(referral)} className="button m-2 buttons">CLOSE</button>
          </div>
        </div>
    </React.Fragment>
  )}

// *************************************************
// Specialist display of a referral (CLAIMED state)
// *************************************************
else if (userType === "installer" && action === "display" && referral.specialist_action === 'owned') {
console.log('Referral record:', referral);

const getSourceLabel = (type) => {
  const typeMap = {
    'dealer': 'Dealer Referral',
    'specialist': 'Specialist',
    'internal campaign': 'Internal Campaign',
    'returning customer': 'Returning Customer',
    'organic': 'Organic',
    'google': 'Google',
    'insta': 'Instagram',
    'instagram': 'Instagram',
    'facebook': 'Facebook',
    'yelp': 'Yelp'
  };
  return typeMap[type?.toLowerCase()] || 'Lead';
};

const getSourceIcon = (type) => {
  const iconMap = {
    'dealer': 'fa-solid fa-handshake',
    'specialist': 'fa-solid fa-user',
    'internal campaign': 'fa-solid fa-bullhorn',
    'returning customer': 'fa-solid fa-arrow-rotate-right',
    'organic': 'fa-solid fa-seedling',
    'google': 'fa-brands fa-google',
    'insta': 'fa-brands fa-instagram',
    'instagram': 'fa-brands fa-instagram',
    'facebook': 'fa-brands fa-facebook',
    'yelp': 'fa-brands fa-yelp'
  };
  return iconMap[type?.toLowerCase()] || 'fa-solid fa-circle-info';
};

const showAddedBy = referral.referral_type?.toLowerCase() === 'specialist'
  && !referral.campaign_id
  && referral.referring_user_id > 0
  && referral.referring_user_name;

return (
    <React.Fragment>
          <div className="card text-center">
            <div className="mt-4 mb-4">
                <h6>
                  Created: {moment(referral.claimed_date || referral.claimed_at).format("MM/DD/YYYY")}
                  <span className="mx-2">|</span>
                  <i className={`${getSourceIcon(referral.referral_type)} mr-1`}></i>
                  {getSourceLabel(referral.referral_type)}
                </h6>
                {showAddedBy && (
                  <p className="text-muted mb-2">
                    <small>Added by: {referral.referring_user_name}</small>
                  </p>
                )}
                <div>
                  <p>{referral.Year} {referral.Make} {referral.Model}</p>
                </div>
                <div>
                  <h6>Customer: {referral.customer_name}</h6>
                  <p>Email: <a href={`mailto:${referral.customer_Email_Address}`}>{referral.customer_Email_Address}</a></p>
                  {referral.customer_phone_number && (
                    <p>Phone: <a href={`tel:${referral.customer_phone_number}`}>{referral.customer_phone_number}</a></p>
                  )}
                </div>
                {referral.requested_service && (
                  <div>
                    <h6>Interested in: {referral.requested_service}</h6>
                  </div>
                )}

                {/* Campaign Info Section - Shows why the customer reached out */}
                {referral.campaign_id > 0 && (
                  <div className="mt-3 mb-3" style={{
                    backgroundColor: '#e7f3ff',
                    border: '1px solid #b6d4fe',
                    borderRadius: '8px',
                    padding: '15px',
                    textAlign: 'left',
                    maxWidth: '400px',
                    margin: '15px auto'
                  }}>
                    <h6 style={{ color: '#0c5460', marginBottom: '10px' }}>
                      <i className="fa fa-bullhorn mr-2"></i>
                      Campaign Lead
                    </h6>
                    {referral.campaign_name && (
                      <p style={{ marginBottom: '5px' }}>
                        <strong>Campaign:</strong> {referral.campaign_name}
                      </p>
                    )}
                    {referral.campaign_description && (
                      <p style={{ marginBottom: '5px', fontStyle: 'italic', color: '#495057' }}>
                        "{referral.campaign_description}"
                      </p>
                    )}
                    {referral.promo_code && (
                      <p style={{ marginBottom: '5px' }}>
                        <strong>Promo Code:</strong>{' '}
                        <span className="badge badge-success">{referral.promo_code}</span>
                      </p>
                    )}
                    {referral.discount_description && (
                      <p style={{ marginBottom: '0' }}>
                        <strong>Offer:</strong> {referral.discount_description}
                      </p>
                    )}
                  </div>
                )}

                <div className="mt-3 mb-3">
                  <p><strong>Click "Convert" when talking with this customer to populate an estimate.</strong></p>
                </div>
                <button
                  type="button"
                  onClick={() => onConvertToEstimate(referral)}
                  className="button btn-warning m-2 buttons"
                >
                  CONVERT TO ESTIMATE
                </button>
                <button type="button" onClick={() => onCancel(referral)} className="button m-2 buttons">CLOSE</button>
          </div>
        </div>
    </React.Fragment>
  )}

//************************************************************************
//*******************  Dealer Referral Display ***************************
//************************************************************************

// *************************************************
// Dealer display of an existing referral
// *************************************************
else {

return (
    <React.Fragment>
          <div className="card text-center">
            <div className="mt-4 mb-4">
                <h6>Sold date : {moment(referral.availableDate || referral.created_at).format("MM/DD/YYYY")}</h6>
                <div>
                    <h6>VIN : {referral.VIN}</h6>
                </div>
                <div>
                  <p>{referral.Year} {referral.Make} {referral.Model} </p>
                </div>
                <div>
                  <h6>Customer Email : {referral.customer_Email_Address} </h6>
                </div>
                <div>
                  <h6>Customer Name : {referral.customer_name} </h6>
                </div>
                <div>
                  <div style={(messageBoxStyle)}>
                    {stateMessage(referral.status, referral, bonus)}
                  </div>
                </div>
                <button type="button" onClick={() => onCancel(referral)} className="button btn-success m-2 buttons">CANCEL</button>
          </div>
        </div>
    </React.Fragment>
  )};
    }
  }
};


export default referralState;